<template>

<div class="main-div">
  <button v-on:click="$router.go(-1)" class="back-button"></button>
  <div class=" logo-container"><img class="logo" src="../assets/img/logo.png" v-on:click="home()"></div>
  <!--<h2 class="home" v-on:click="home()">Home</h2>-->
  <h2 class="titel">{{ $route.params.title }}</h2>
  <h2 class="time"> {{ times }}</h2>
  <!-- <div class="settings" id="settings" v-on:click="showingsettings = !showingsettings" v-global-click-outside:mySidenav="showingsettings" :style="showingsettings == true ? {color : 'black',backgroundColor:'rgba(255,255,255,1)'}:{}" ref="settings">
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 172 172" style="fill:#000000;">
    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g :style="showingsettings == true ? {fill : 'black'}:{fill : 'white'}"><path d="M140.24808,94.17717c-2.55492,-1.87408 -4.08142,-4.88408 -4.08142,-8.05533c0,-3.17125 1.5265,-6.18125 4.07783,-8.05175l11.8035,-8.65375c1.88125,-1.38317 2.65883,-3.81625 1.92425,-6.03433c-3.03867,-9.13033 -7.84392,-17.458 -14.28675,-24.75725c-1.55158,-1.74867 -4.05275,-2.3005 -6.192,-1.36167l-13.29058,5.84442c-2.89533,1.27567 -6.26725,1.09292 -9.01567,-0.4945c-2.74483,-1.58383 -4.58667,-4.4075 -4.93425,-7.55725l-1.59817,-14.59133c-0.25442,-2.322 -1.98158,-4.214 -4.26775,-4.68342c-9.30592,-1.90275 -19.08483,-1.935 -28.55558,-0.03583c-2.3005,0.46225 -4.03125,2.35425 -4.28567,4.687l-1.58383,14.49817c-0.34758,3.15333 -2.18942,5.977 -4.94142,7.56083c-2.74483,1.58383 -6.106,1.77375 -9.01208,0.4945l-13.36225,-5.87667c-2.12133,-0.93883 -4.62967,-0.39417 -6.18125,1.35092c-6.46433,7.27058 -11.29108,15.5875 -14.362,24.71067c-0.74533,2.2145 0.02867,4.66192 1.91708,6.04867l11.72825,8.6c2.5585,1.87767 4.085,4.88767 4.085,8.05892c0,3.17125 -1.5265,6.18125 -4.07783,8.05175l-11.8035,8.65375c-1.88125,1.38317 -2.65883,3.81625 -1.92425,6.03433c3.03867,9.13033 7.84392,17.458 14.28675,24.75725c1.55158,1.75225 4.05992,2.30767 6.192,1.36167l13.29058,-5.84442c2.89533,-1.27567 6.26367,-1.09292 9.01567,0.4945c2.74483,1.58383 4.58667,4.4075 4.93425,7.55725l1.59817,14.59133c0.25442,2.322 1.98158,4.214 4.26775,4.68342c4.7085,0.96033 9.546,1.44767 14.38708,1.44767c4.72283,0 9.48867,-0.47658 14.16492,-1.41542c2.3005,-0.46225 4.03125,-2.35425 4.28567,-4.687l1.58742,-14.49817c0.34758,-3.15333 2.18942,-5.977 4.94142,-7.56083c2.74483,-1.58025 6.10958,-1.76658 9.01208,-0.4945l13.36225,5.87667c2.1285,0.94242 4.62967,0.39775 6.18125,-1.35092c6.46433,-7.27058 11.29108,-15.5875 14.362,-24.71067c0.74533,-2.2145 -0.02867,-4.66192 -1.91708,-6.04867zM86,111.08333c-13.85317,0 -25.08333,-11.23017 -25.08333,-25.08333c0,-13.85317 11.23017,-25.08333 25.08333,-25.08333c13.85317,0 25.08333,11.23017 25.08333,25.08333c0,13.85317 -11.23017,25.08333 -25.08333,25.08333z"></path></g></g>
    </svg>
  </div> -->
  <div class="settings">
   <button class="menu" v-on:click.stop="openSettings($event)" aria-label="Settings Menu" ref="settings" v-global-click-outside:mySidenav="showingsettings">
      <svg width="100%" height="100%" viewBox="0 -50 100 200">
        <path class="line line1" d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
        <path class="line line2" d="M 20,50 H 80" />
        <path class="line line3" d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
      </svg>
    </button>
  </div>

  <!-- <h3 class="profile" v-on:click="$router.push({ name: 'calender'});">calender</h3> -->
  <!-- <h3 class="profile">
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="28" height="28" viewBox="0 0 172 172" style=" fill:#000000;">
    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g id="original-icon" fill="#ffffff"><path d="M86,14.33333c-19.72655,0 -35.83333,16.1068 -35.83333,35.83333c0,19.72653 16.10679,35.83333 35.83333,35.83333c19.72655,0 35.83333,-16.1068 35.83333,-35.83333c0,-19.72653 -16.10679,-35.83333 -35.83333,-35.83333zM86,25.08333c13.91682,0 25.08333,11.16652 25.08333,25.08333c0,13.91681 -11.16651,25.08333 -25.08333,25.08333c-13.91682,0 -25.08333,-11.16652 -25.08333,-25.08333c0,-13.91681 11.16651,-25.08333 25.08333,-25.08333zM42.92302,100.33333c-7.81099,0 -14.25635,6.44536 -14.25635,14.25635v5.45198c0,12.91493 8.16738,22.90548 19.01546,28.89063c10.84808,5.98514 24.58691,8.73438 38.31787,8.73438c13.73096,0 27.46979,-2.74923 38.31787,-8.73437c9.24959,-5.10322 16.21091,-13.25792 18.16162,-23.51563h0.86084v-10.82698c0,-7.81099 -6.45236,-14.25635 -14.26335,-14.25635zM42.92302,111.08333h86.15397c2.00018,0 3.51335,1.50617 3.51335,3.50635v0.07698h-0.007v5.375c0,8.58507 -4.8222,14.71952 -13.45849,19.48438c-8.6363,4.76486 -20.87664,7.39063 -33.12484,7.39063c-12.2482,0 -24.48854,-2.62577 -33.12484,-7.39062c-8.6363,-4.76486 -13.45849,-10.89931 -13.45849,-19.48438v-5.45198c0,-2.00018 1.50617,-3.50635 3.50635,-3.50635z"></path></g></g>
    </svg>
  </h3> -->
  <div class="tool" id="user-notification" v-on:mouseover.stop="$state.showtool = true" v-on:mouseleave.stop="$state.showtool = false"><div class="tool-anim"><Tooltips v-bind:showtool="$state.showtool"></Tooltips></div></div>
  <transition name="slide-in">
  <!-- <div id="mySidenav" class="sidenav" :style="showingsettings == true ? {width : '50%'}:{width : '0%'}"> -->
  <div id="mySidenav" class="sidenav" v-show="showingsettings">
    <Settings ></Settings>
</div>
</transition>
</div>
</template>
<script>
import Tooltips from '../components/tooltips.vue';
import Settings from '../Subviews//Settings/Settings.vue';
export default {
    components: {
        Settings,
        Tooltips
  },
  methods: {
    test(){
      // console.log("hi")
      this.showingsettings = !this.showingsettings
    },
    time() {
      var self = this;
      var d;
      setInterval(() => {
        d = new Date();
        this.times = d.toLocaleTimeString("en-us");
      }, 1000);
    },
    home(){
      window.location.href='https://cubeitdone.com/'
    },
    openSettings(event){
      this.showingsettings = !this.showingsettings;
      event.target.classList.toggle('opened');
      event.target.setAttribute('aria-expanded', event.target.classList.contains('opened'))
    }
    // settings(){
    //   this.showingsettings == true ? document.getElementById("mySidenav").style.width = '23em':document.getElementById("mySidenav").style.width = '0em';
    // }
  },

  mounted() {
    this.time();
  },
  data() {
    return {
      times: "",
      
      showingsettings:false,
      title:""
    };
  }
};
</script>
<style scoped>
.logo-container{
  height:100%;
  width:10%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: #111; */
}
.logo{

  width:auto;
  height:70%;
  transition: all 0.2s ease-in-out;
}
h2{
  margin:0px;
}
.time{
  font-weight:bold;
  display:inline-block;
  height:100%;
  margin:0;
  text-align:right;
  width:20%;
  font-size: 3vh;
  transition: all 0.2s ease-in-out;
}
.titel{
margin:auto;
height:70%;
display:inline-block;
color:white;
text-align:center;
font-size: 5vh;
height:100%;
width:50%;
transition: all 0.2s ease-in-out;

}
.home{
display:inline-block;
text-align:center;
width:10%;

}
.home:hover{
cursor:pointer;
}
.logout{
margin:0px;
display:inline-block;
text-align:center;
width:15%;
height:100%;
font-size: 3vh;
transition: all 0.2s ease-in-out;
}
.logout:hover{
cursor:pointer;
}

.settings{
  background-color: rgba(0, 0, 0, 0);
  transition: all 0.2s ease-in-out;
  margin:0px;
  display:inline-block;
  text-align:center;
  width:7.5%;
  height:100%;
  font-size: 3vh;
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}


/* .settings { 
display: inline-block;
background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iNTAiIGhlaWdodD0iNTAiCnZpZXdCb3g9IjAgMCA1MCA1MCIKc3R5bGU9IiBmaWxsOiMwMDAwMDA7Ij48cGF0aCBkPSJNIDUgOSBMIDUgMTEgTCA0NSAxMSBMIDQ1IDkgTCA1IDkgeiBNIDUgMjQgTCA1IDI2IEwgNDUgMjYgTCA0NSAyNCBMIDUgMjQgeiBNIDUgMzkgTCA1IDQxIEwgNDUgNDEgTCA0NSAzOSBMIDUgMzkgeiI+PC9wYXRoPjwvc3ZnPg==') 50% 50% no-repeat;
background-size: 100%; } */

.settings:hover{
  cursor:pointer;
  background-color: rgba(122, 122, 122, 0.479)!important;
}
.profile{
  background-color: rgba(0, 0, 0, 0);
  transition: all 0.2s ease-in-out;
  margin:0px;
  display:inline-block;
  text-align:center;
  width:7.5%;
  height:100%;
  font-size: 3vh;
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}
.profile:hover{
  cursor:pointer;
   background-color: rgba(122, 122, 122, 0.479)!important;
}
.settings-menu{
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  position:absolute;
  right:0px;
  bottom:0px;
  height:90vh;
  width:0;
  z-index:1000;
  transition: all 0.2s ease-in-out;
}

.main-div{
  display:flex;
  width:100%;
  margin: 0px;
  height:10vh;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 10%,
    rgba(0, 0, 0, 0) 100%
  );
  color: white;
  transition: all 0.4s;
}
.tool{
display:inline-block;
width:1%;
border-radius:5px 0px 0px 5px;
margin:0px;
/* background-color: rgb(255, 255, 255); */
background-color:#FEE715FF;
transform:10px 20px;
z-index:20001;
height:100%;
transition: all 0.2s ease-in-out; 
}
.tool-img{
position:absolute;
width:10px;
height:auto;
margin-left:80px;
margin-right:80px;
margin-bottom:10px;
opacity:0.1;
}
.tool-anim{
  pointer-events: none;
  display:unset;
  opacity:0;
  transition: all 0.2s ease;
  background-color: rgba(0, 0, 0, 0.377);
  border-radius:5px;
  width:40vw;
  height:90vh;
  top:10vh;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  right:0px;
  position:fixed;
}
.tool:hover .tool-anim{
  /* width:40vw; */
  opacity:1;
}
.showing{
  width:30%;
  opacity:1;
} 
.filler{
  color:rgba(0, 0, 0, 1);
  position: absolute;
  margin:0px;
}
/* The side navigation menu */
.sidenav {
  height: 90vh;
  /* width: 50%; */
  width:960px;
  position: fixed;
  z-index: 1;
  bottom: 0; 
  right: 0;
  background-color: #111;
  overflow-x: hidden;
  /* transition: 0.5s; */
  z-index:1000;
  box-shadow: 0px 0px 50px black;
  transform: translate(0%);
}

.slide-in-enter-active {
  transition: all 0.5s ease 0s;
}
.slide-in-leave-active {
  transition: all 0.5s ease 0s;
}
.slide-in-enter,
.slide-in-leave-to{
  transform: translate(100%);
}


.loading{
  background-color: #4285f4;
  animation-name: color;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}



@keyframes color {
  0% {
    background-color: #222;
  }
  50% {
    background-color: #4285f4;
  }
  100% {
    background-color: #222;
  }
}

/* ipad pro Portrait */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen 
  and (min-device-width: 1024px) 
  and (max-device-width: 1024px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 2) {
          .titel{
    font-size: 2.5vh;
    padding-top:3.6vh;
  }
  .time{
    font-size:1vh;
    padding:0px;
    padding-top:4.3vh;
    text-align: center;
  }
  .logout{
    font-size:2vh;
    padding:0px;
    padding-top:4.5vh;
  }
  .settings{
    font-size:2vh;
    padding:0px;
    padding-top:4.5vh;
  }
  .logo{
    width:auto;
    height:70%;
    /* padding-top:2vh; */
  }

}

/*Ipad Portrait */
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 2) {
      .titel{
    font-size: 2.5vh;
    padding-top:3.6vh;
  }
  .time{
    font-size:2vh;
    padding:0px;
    padding-top:4.3vh;
    text-align: center;
  }
  .logout{
    font-size:2vh;
    padding:0px;
    padding-top:4.5vh;
  }
  .settings{
    font-size:2vh;
    padding:0px;
    padding-top:4.5vh;
  }
  .logo{
   width:auto;
    height:70%;
  }
  }
  /* Portrait */
@media only screen 
  and (min-device-width: 375px) 
  and (max-device-width: 812px) 
  and (-webkit-min-device-pixel-ratio: 3)
  and (orientation: portrait) { 
  .titel{
    font-size: 2vh;
    padding-top:4vh;
  }
  .time{
    font-size:1.5vh;
    padding:0px;
    padding-top:4.5vh;
  }
  .logout{
    font-size:1.5vh;
    padding:0px;
    padding-top:4.5vh;
  }
  .settings{
    font-size:1.5vh;
    padding:0px;
    padding-top:4.5vh;
  }
  .logo{
    width:auto;
    height:70%;
  }

}


@media screen and (max-height: 450px) {
  .sidenav a {font-size: 18px;}
}/*
@media (max-width:1140px) {
  .titel{
    font-size: 3vh;
    padding-top:4vh;
  }
  .time{
    font-size:3vh;
    padding:0px;
    padding-top:4vh;
    text-align: center;
  }
  .logout{
    font-size:3vh;
    padding:0px;
    padding-top:4.5vh;
  }
  .settings{
    font-size:3vh;
    padding:0px;
    padding-top:4.5vh;
  }
  .logo{
    width:10vh;
    height:auto;
    padding-top:2vh;
  }
}*/
@media (max-width:610px) {
  .titel{
    font-size: 2vh;
    /* padding-top:4vh; */
  }
  .time{
    font-size:1.5vh;
    padding:0px;
    /* padding-top:4.5vh; */
  }
  .logout{
    font-size:1.5vh;
    padding:0px;
    /* padding-top:4.5vh; */
  }
  .settings{
    font-size:1.5vh;
    padding:0px;
    /* padding-top:4.5vh; */
  }
  .logo{
    width:auto;
    height:70%;
  }
}
.menu {
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
  height:100%;
  width:100%;
  background-color: transparent;
}
.line {
  fill: none;
  pointer-events: none;
  stroke: rgb(255, 255, 255);
  stroke-width: 6;
  transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
    stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
}
.line1 {
  stroke-dasharray: 60 207;
  stroke-width: 6;
}
.line2 {
  stroke-dasharray: 60 60;
  stroke-width: 6;
}
.line3 {
  stroke-dasharray: 60 207;
  stroke-width: 6;
}
.opened .line1 {
  stroke-dasharray: 90 207;
  stroke-dashoffset: -134;
  stroke-width: 6;
}
.opened .line2 {
  stroke-dasharray: 1 60;
  stroke-dashoffset: -30;
  stroke-width: 6;
}
.opened .line3 {
  stroke-dasharray: 90 207;
  stroke-dashoffset: -134;
  stroke-width: 6;
}
</style>
